import { BiCommentAdd } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { TextInput } from "screens/perfilAutonomo/components/TextInput";
import { SecondaryButton } from "screens/perfilAutonomo/components/secondaryButton.component";
import { PrimaryButton } from "screens/perfilAutonomo/components/primaryButton.component";
import { toast } from "react-toastify";
import { useState } from "react";
import { SelectComponent } from "screens/perfilAutonomo/components/SelectComponent";
import { fetchAutonomo } from "screens/perfilAutonomo/api/getAutonomo";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import * as S from "./styles";
import { postSugestao } from "./postSugestao";
import { fetchTipoSugestao } from "./getTipoSugestao";

export const ModalNovaSugestao = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const [data, setData] = useState<{
    tipoSugestao: number | null;
    sugestao: string;
  }>({
    tipoSugestao: null,
    sugestao: "",
  });

  const { username } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const { data: user } = fetchAutonomo(username);
  const authToken = user?.userAdResponse?.token ?? "";

  const { data: tipoSugestaoOptions, isLoading: loadingTipoSugestao } =
    fetchTipoSugestao(authToken, open);

  const handleClose = () => {
    onClose();
    setTimeout(() => {
      setData({
        tipoSugestao: null,
        sugestao: "",
      });
    }, 250);
  };

  const handleSubmit = () => {
    postSugestao({ ...data, authToken })
      .then(({ success, notifications }) => {
        if (success) toast.success("Sugestão enviada com sucesso");
        else throw new Error(notifications?.[0]?.message ?? "");
      })
      .catch((error) => {
        toast.error(
          error
            ? `Erro: ${error}`
            : "Erro ao enviar sugestão, por favor tente novamente mais tarde."
        );
        console.error(error);
      })
      .finally(() => {
        handleClose();
      });
  };

  return (
    <S.DialogContainer open={open} onClose={handleClose} maxWidth="md">
      <S.Container>
        <S.IconContainer>
          <div className="icon-wrapper">
            <BiCommentAdd color="#333" />
          </div>
          <h1 className="title center">{"Nova Sugestão"}</h1>
          <IoClose size={26} className="exit" onClick={handleClose} />
        </S.IconContainer>

        <p className="disclaimer">
          {
            "Os dados enviados são totalmente anônimos e não permitem identificar você. As informações serão utilizadas apenas para fins de melhoria e estatísticas do serviço."
          }
        </p>

        <S.Form>
          <S.Field>
            <p>{"Tipo de Sugestão"}</p>
            <SelectComponent
              data={tipoSugestaoOptions ?? []}
              value={data?.tipoSugestao}
              onChange={(val: number | null) => {
                setData((prev) => ({
                  ...prev,
                  tipoSugestao: val,
                }));
              }}
              isLoading={loadingTipoSugestao}
              disabled={loadingTipoSugestao || !tipoSugestaoOptions?.length}
              renderLabel
            />
          </S.Field>

          <S.Field>
            <p>{"Descritivo"}</p>
            <TextInput
              value={data.sugestao}
              onChange={(val) => {
                setData((prev) => ({
                  ...prev,
                  sugestao: val,
                }));
              }}
              placeholder="Conte-nos sua sugestão ou observação"
              multiline
            />
          </S.Field>
        </S.Form>

        <S.Row>
          <div id="dummy" />
          <S.Row>
            <SecondaryButton content="Cancelar" onClick={handleClose} />
            <PrimaryButton content="Enviar sugestão" onClick={handleSubmit} />
          </S.Row>
        </S.Row>
      </S.Container>
    </S.DialogContainer>
  );
};
